<div class="host-note-v2">
  <div class="content">
    <form nz-form [formGroup]="form">
      <div class="left">
        <!-- 类型 -->
        <div class="left-item">
          <p class="title">{{ "component.note.type" | translate }}</p>
          <nz-radio-group formControlName="type" (ngModelChange)="typeChange()">
            <label nz-radio [nzValue]="1">
              <span>{{ "word.income" | translate }}</span>
            </label>
            <label nz-radio [nzValue]="-1">
              <span>{{ "word.outcome" | translate }}</span>
            </label>
          </nz-radio-group>
        </div>
        <!-- 项目 -->
        <div class="left-item">
          <p class="title">{{ "component.note.item" | translate }}</p>
          <nz-select
            style="width: 308px;"
            nzPlaceHolder="{{ 'placeholder.outcome_item' | translate }}"
            formControlName="action_type"
          >
            <nz-option
              *ngFor="let opt of listOfItemOption"
              [nzLabel]="opt.item_name"
              [nzValue]="opt.code"
            ></nz-option>
          </nz-select>
        </div>
        <!-- 币种 -->
        <div class="left-item" *ngIf="orderOrWhole === 'whole'">
          <p class="title">
            {{ "component.note.currency" | translate }}
          </p>
          <nz-select style="width: 308px;" formControlName="currency_type">
            <nz-option
              *ngFor="let currency of currencyList"
              [nzLabel]="currency"
              [nzValue]="currency"
            ></nz-option>
          </nz-select>
        </div>
        <!-- 金额 -->
        <div class="left-item">
          <p class="title">
            {{ "component.note.amount" | translate }}
          </p>
          <div class="amount-with-currency">
            <p *ngIf="orderOrWhole === 'order'">
              {{ currency }}
            </p>
            <host-input-with-error
              [showError]="
                checking &&
                (!form.get('amount').value || form.get('amount').value === '')
              "
              errorText="{{ 'errorText.fee_required' | translate }}"
            >
              <nz-input-number
                [nzStep]="1"
                [nzMin]="0"
                [nzMax]="maxAmount"
                [nzPrecision]="2"
                [style.width]="orderOrWhole === 'order' ? '270px' : '308px'"
                [nzPlaceHolder]="amountPlaceHolder"
                formControlName="amount"
              >
              </nz-input-number>
            </host-input-with-error>
          </div>
        </div>
        <!-- 交易方式 -->
        <div class="left-item">
          <p class="title">
            {{ "component.note.payment_method" | translate }}
          </p>
          <host-input-with-error
            [showError]="checking && form.get('payment_method').value === null"
            errorText="{{ 'errorText.choose_transaction_method' | translate }}"
          >
            <nz-select
              style="width: 308px;"
              nzPlaceHolder="{{ 'placeholder.payment_method' | translate }}"
              formControlName="payment_method"
            >
              <nz-option
                *ngFor="let opt of listOfMethodOption"
                [nzLabel]="opt.method_name"
                [nzValue]="opt.code"
              ></nz-option>
            </nz-select>
          </host-input-with-error>
        </div>
        <!-- 相关房间 -->
        <div class="left-item" *ngIf="orderOrWhole === 'whole'">
          <p class="title">
            {{ "component.note.related_house" | translate }}
          </p>
          <div *ngIf="form.get('type').value === 1 || createOrEdit === 'edit'">
            <host-search-house-in-group-and-type-with-input
              [allowMultiSelect]="false"
              [showWidth]="308"
              [noBorder]="true"
              [defaultHouses]="defaultHouses"
              [defaultHouseTitle]="defaultHouseTitle"
              (checkedHousesChange)="checkedHousesChange($event)"
            >
            </host-search-house-in-group-and-type-with-input>
          </div>
          <div
            *ngIf="form.get('type').value === -1 && createOrEdit === 'create'"
          >
            <host-search-house-in-group-and-type-with-input
              [allowMultiSelect]="true"
              [showWidth]="308"
              [noBorder]="true"
              [defaultHouses]="defaultHouses"
              [defaultHouseTitle]="defaultHouseTitle"
              (checkedHousesChange)="checkedHousesChange($event)"
            >
            </host-search-house-in-group-and-type-with-input>
          </div>
        </div>
        <!-- 时间分摊 -->
        <div
          class="left-item"
          *ngIf="
            form.get('type').value === -1 &&
            createOrEdit === 'create' &&
            orderOrWhole === 'whole'
          "
        >
          <p class="title">
            {{ "component.note.time_sharing" | translate }}
          </p>
          <nz-radio-group formControlName="shareChecked">
            <label nz-radio [nzValue]="0">
              {{ "component.note.no_time_sharing" | translate }}
            </label>
            <label nz-radio [nzValue]="1">
              {{ "component.note.monthly_share" | translate }}
            </label>
          </nz-radio-group>
        </div>
        <!-- 分摊月份 -->
        <div class="left-item" *ngIf="form.get('shareChecked').value === 1">
          <p class="title">
            {{ "component.note.share_months" | translate }}
          </p>
          <div class="month-border">
            <host-input-with-error
              [showError]="
                checking &&
                form.get('shareChecked').value === 1 &&
                (!form.get('month_share').value ||
                  form.get('month_share').value === '')
              "
              errorText="{{ 'errorText.share_month_required' | translate }}"
            >
              <host-month-search
                [from]="'note'"
                [showWidth]="308"
                (onSelect)="chooseShareMonths($event)"
              ></host-month-search>
            </host-input-with-error>
          </div>
        </div>
        <!-- 交易时间 -->
        <div class="left-item">
          <p class="title" *ngIf="form.get('shareChecked').value === 0">
            {{ "component.note.time" | translate }}
          </p>
          <p class="title" *ngIf="form.get('shareChecked').value === 1">
            {{ "component.note.moment" | translate }}
          </p>
          <div *ngIf="form.get('shareChecked').value === 0">
            <nz-date-picker
              formControlName="action_date"
              [nzDisabledTime]="disabledTime"
              [nzFormat]="angularDateFormat"
              [nzShowTime]="true"
              [nzAllowClear]="false"
              [nzStyle]="{ width: '308px' }"
            ></nz-date-picker>
          </div>
          <div *ngIf="form.get('shareChecked').value === 1">
            <div class="select-day-time">
              <nz-select formControlName="action_day" class="select-day">
                <nz-option
                  *ngFor="let day of dayList"
                  [nzLabel]="day.title"
                  [nzValue]="day.id"
                ></nz-option>
              </nz-select>
              <host-input-with-error
                class="select-time"
                [showError]="
                  checking &&
                  form.get('shareChecked').value === 1 &&
                  (!form.get('action_time').value ||
                    form.get('action_time').value === '')
                "
                errorText="{{ 'errorText.payment_time_required' | translate }}"
              >
                <nz-time-picker
                  [nzFormat]="angularTimeFormat"
                  [nzUse12Hours]="use12Hours"
                  formControlName="action_time"
                  [nzDefaultOpenValue]="defaultOpenValue"
                ></nz-time-picker>
              </host-input-with-error>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="right">
      <!-- 凭证 -->
      <div class="right-item">
        <p class="right-title">
          {{ "component.note.certificate" | translate }}
        </p>
        <host-upload-voucher
          name="voucher"
          [(ngModel)]="imageList"
          (ngModelChange)="fileChange($event)"
        ></host-upload-voucher>
      </div>
      <!-- 备注 -->
      <div class="right-item">
        <p class="right-title">{{ "order.guest_remarks" | translate }}</p>
        <textarea
          style="width: 341px;"
          rows="7"
          [(ngModel)]="note"
          nz-input
          placeholder="{{ 'placeholder.input_remarks' | translate }}"
        ></textarea>
      </div>
    </div>
  </div>

  <div class="footer">
    <div
      class="footer-info"
      *ngIf="form.get('type').value === -1 && orderOrWhole === 'whole'"
    >
      <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
      <p style="padding-left: 8px;">
        {{ "component.note.outcome_share_info" | translate }}
      </p>
    </div>
    <div *ngIf="form.get('type').value === 1 || orderOrWhole === 'order'"></div>
    <div class="button">
      <button nz-button nzType="primary" (click)="addNote()">
        {{ "word.save" | translate }}
      </button>
      <button nz-button (click)="cancel()">
        {{ "word.cancel" | translate }}
      </button>
    </div>
  </div>
</div>
